import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getGlobalGroups = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-group`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global groups:', error.response?.data || error);
    throw error;
  }
};

export const getGlobalGroupById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-group/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global group:', error.response?.data || error);
    throw error;
  }
};

// Fetches both global groups and lcoal groups
export const getPaginatedGlobalGroupsCombined = async ({
  page = 1,
  pageSize = 10,
  search = '',
  manufacturerId,
  classId,
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-group/paginated-combined`, { params: { page, pageSize, search, manufacturerId, classId },
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach((v) => query.append(key, v));
          } else if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching global groups:', error.response?.data || error);
    throw error;
  }
};

export const getPaginatedGlobalGroups = async ({
  page = 1,
  pageSize = 10,
  search = '',
  manufacturerId,
  classId,
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-group/paginated`, {      params: { page, pageSize, search, manufacturerId, classId },
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach((v) => query.append(key, v));
          } else if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching global groups:', error.response?.data || error);
    throw error;
  }
};

export const createGlobalGroup = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/global-group`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating global group:', error.response?.data || error);
    throw error;
  }
};

export const updateGlobalGroup = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/global-group/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating global group:', error.response?.data || error);
    throw error;
  }
};

export const deleteGlobalGroup = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/global-group/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting global group:', error.response?.data || error);
    throw error;
  }
};
